"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#F6F9FD",
  z100: "#E4EEFA",
  z200: "#BCD9FA",
  z300: "#79B6FC",
  z400: "#539CEE",
  z500: "#2781E7",
  z600: "#0366D6",
  z700: "#024FA6",
  z800: "#023774",
  z900: "#011F41"
};
exports["default"] = _default;